import ol from 'openlayers';
import React, { Component } from 'react';
import ReactDOM from 'react-dom';

import { placeId } from './reducer';

import 'openlayers/css/ol.css';
import './ol-controls.css';
import './popup.css';
import './logo-control.css';

import PopupContentContainer from './PopupContentContainer'
import BUILDING_TYPE_ICONS from './icons';

require('./lib/ol3-sidebar.js')(ol);

class MapComponent extends Component {

  olMap = null
  olPlaceLayer = null
  popupElement = null
  popupCloser = null
  popup = null
  olSidebarControl = null
  olTranslateInteraction = null
  olSelectInteraction = null
  olHoverInteraction = null
  olStyleCache = null
  olClusterLayer = null
  olAtlasManager = null

  async loadFeatures () {
    let response = await fetch('/api/features?markers=true', {credentials: 'include'})
    let data = await response.json()
    return data
  }

  async loadFeatureProperties(id) {
    let response = await fetch(`/api/features/${id}`, {credentials: 'include'})
    let data = await response.json()
    return data
  }

  onSaveFeatureGeom(id, placeOrCluster) {
    const clusterFeature = this.olClusterLayer.getSource().getFeatures().filter(
      cluster => cluster.getProperties()['features'].filter(
        feature => feature.getProperties()['id'] == id
      ).length
    )[0],
      clusterFeatureGeom = clusterFeature ? clusterFeature.getGeometry() : null;

    const placesFeature = this.olPlaceLayer.getSource().getFeatures().filter(
        feature => feature.getProperties()['id'] == id
    )[0],
      placesFeatureGeom = placesFeature ? placesFeature.getGeometry() : null;

    if (clusterFeatureGeom && placesFeatureGeom) {
      console.log('cluster coords before: ' + clusterFeatureGeom.getCoordinates())
      console.log('places coords before: ' + placesFeatureGeom.getCoordinates())
      if (placeOrCluster == 'place') {
        console.log('place')
        clusterFeatureGeom.setCoordinates(placesFeatureGeom.getCoordinates())
      } else if (placeOrCluster == 'cluster') {
              console.log('cluster')
        placesFeatureGeom.setCoordinates(clusterFeatureGeom.getCoordinates())
      } else {
        console.error('Undefined place save type: ' + placeOrCluster)
      }
      console.log('cluster coords after: ' + clusterFeatureGeom.getCoordinates())
      console.log('places coords after: ' + placesFeatureGeom.getCoordinates())
    }
    this.updateAllPlaces()
  }

  updateAllPlaces () {
    //console.log('updateAllPlaces started')
    const { onVisiblePlacesChange } = this.props
    const features = this.olPlaceLayer.getSource().getFeatures()
    if (features) {
      const places = features.map(feature => feature.getProperties())
      onVisiblePlacesChange(places)
    }
    //console.log('updateAllPlaces ended')
  }

  async updateFeature(feature) {
    //console.log('updateFeature started')
    const properties = await this.loadFeatureProperties(feature.getProperties()['id'])

    feature.setProperties(properties['properties'])
    //console.log('updateFeature ended')
  }

  async updateManyFeatures(features) {
      const featurePromises = features.map(feature => this.updateFeature(feature))
      await Promise.all(featurePromises)
  }

  async updateSelectionByFeature (feature, zoomIn=false) {
    // console.log('updateSelectionByFeature')

    const pos = feature.getGeometry().getFirstCoordinate()

    this.showPopup(
      pos
    )

    if (zoomIn === true) {
      // this.olMap.getView().fit(
      //   feature.getGeometry().getExtent(),
      //   {
      //     duration: 1000
      //   }
      // )
      const mapSize = this.olMap.getSize();
      const halfMapSize = mapSize.map(coord => coord / 2);
      this.olMap.getView().centerOn(
        pos,
        mapSize,
        [halfMapSize[0] * 1.3, halfMapSize[1] * 1.5]
      )
    }    
  }

  clearSelection () {
    const { onSelectClick, openPanel } = this.props
    openPanel(false)
    this.hidePopup()
    this.olSidebarControl.close();
    this.olSelectInteraction.getFeatures().clear()
    onSelectClick(null)
  }

  async updateSelection (ids, zoomIn=true) {
    // console.log('updateSelection('+ids+')')
    if (typeof(ids) == 'number') {
      ids = [ids]
    }
    const layer = this.olPlaceLayer,
      layerSource = layer ? layer.getSource() : null,
      features = layerSource ? layerSource.getFeatures() : null;
    if (features) {
      const selected = features.filter(feature => (ids || []).includes(placeId(feature.getProperties())))
      
      if (selected.length > 0) {
        let feature = selected[0]
        await this.updateSelectionByFeature(feature, zoomIn)
      }
    }
  }

  async selectHandler (event) {
    const {onSelectClick, onCollapseSidebar, editMode, waitingForResponse, 
      changeShowFilters, isPanelOpened } = this.props
    
    waitingForResponse(true)

    const clusterWasSelected = event.selected.length > 0;

    this.clearSelection()
    
    if (clusterWasSelected) {
      const
        selectedCluster = event.selected[0],
        selectedFeatures = selectedCluster.get('features'),
        selectedGeometry = selectedCluster.get('geometry');
      
      if (selectedFeatures.length == 1) {
        const
          feature = selectedFeatures[0],
          featureId = placeId(feature.getProperties())
        
        await this.updateManyFeatures(selectedFeatures)
        this.updateAllPlaces()

        await this.updateSelectionByFeature(feature, false)

        onSelectClick(featureId)
        changeShowFilters(false)
      }
      else {
        // freaking hack :(
        const uniqCoordinates = Array.from(
          new Set(
            selectedFeatures.map(
              f => f.getGeometry().getCoordinates().toString()
            )
          )
        ).map(
          coords => coords.split(',')
        )
        if (uniqCoordinates.length == 1) {
          await this.updateManyFeatures(selectedFeatures)
          this.updateAllPlaces()
          this.showPopup(uniqCoordinates[0])
          onSelectClick(selectedFeatures.map(feature => placeId(feature.getProperties())))
        }
        else {
          const bbox = ol.extent.boundingExtent(
            uniqCoordinates    
          )
          this.olMap.getView().fit(
            bbox,
            {duration: 500}
          )
        }
      }
    }
    waitingForResponse(false)
  }

  clickHandler (event) {
    const selectedFeaturesCount = this.olSelectInteraction.getFeatures().getLength()
    if (selectedFeaturesCount == 0) {
      this.clearSelection()
    }
  }

  hoverHandler (event) {
    const
        selectedCluster = event.selected[0],
        selectedFeatures = selectedCluster ? selectedCluster.get('features') : null,
        selectedFeature = selectedFeatures && selectedFeatures.length == 1 ? selectedFeatures[0] : null;

    if (selectedFeature) {
      document.body.style.cursor = 'pointer';
      //console.log('hover on single id ' + placeId(selectedFeature.getProperties()))
    } else if (selectedFeatures) {
      //console.log('hover on cluster')
      document.body.style.cursor = 'pointer';
      //console.log(selectedFeatures.map(f => f.getProperties()))
    } else {
      document.body.style.cursor = 'default';
    }
  }

  async componentDidMount () {
    const {onLoading, selected, editMode, shouldBeShownIds} = this.props
    
    onLoading(true)
    const data = await this.loadFeatures()
    const placeSrcOptions = {
      features: new ol.format.GeoJSON(
        {
          defaultDataProjection: 'EPSG:4326'
        }
      ).readFeatures(
        data,
        {
          dataProjection: 'EPSG:4326',
          featureProjection: 'EPSG:3857'
        }
      )
    }
    const placeSrc = new ol.source.Vector(placeSrcOptions)
    this.placeSrc = placeSrc
    const tileMapSrc = new ol.source.OSM({crossOrigin: 'anonymous'})
    const mapLayer = new ol.layer.Tile({source: tileMapSrc})
    const projCenter = ol.proj.fromLonLat([60.595828, 56.8260316])
    const olView = new ol.View({center: projCenter, zoom: 9, maxZoom: 17, minZoom: 7})
    const mapElement = ReactDOM.findDOMNode(this.refs.map)
    this.clusterDistance = 65;

    this.olAtlasManager = new ol.style.AtlasManager({
        // we increase the initial size so that all symbols fit into
        // a single atlas image
        initialSize: 256 // or 512 ?
      });

    const iconStyle = (building_type, has_tour) => {
      let styles = [new ol.style.Style({
      image: new ol.style.Icon(({
        anchor: [0.5, 103],
        anchorXUnits: 'fraction',
        anchorYUnits: 'pixels',
        //opacity: 0.75,
        scale: 0.8,
        src: BUILDING_TYPE_ICONS[building_type] ? BUILDING_TYPE_ICONS[building_type] : BUILDING_TYPE_ICONS['empty'],
      })),
      atlasManager: this.olAtlasManager,
      zIndex: 3
    }), new ol.style.Style({
      image: new ol.style.Icon({
        anchor: [0.5, 103],
        anchorXUnits: 'fraction',
        anchorYUnits: 'pixels',
        //opacity: 0.75,
        scale: 0.8,
        src: BUILDING_TYPE_ICONS['shadow'],
      }),
      atlasManager: this.olAtlasManager,
      zIndex: 2
    })];
    if (has_tour) {
      styles.push(
        new ol.style.Style({
          image: new ol.style.Icon({
            anchor: [0.5, 103],
            anchorXUnits: 'fraction',
            anchorYUnits: 'pixels',
            //opacity: 0.75,
            scale: 1,
            src: BUILDING_TYPE_ICONS['photo'],
          }),
          atlasManager: this.olAtlasManager,
          zIndex: 1  
        })
      )
    }
    return styles;
  }

    this.placeSrc.getFeatures().forEach(feature => {
      feature.setId(feature.get('id'))
    })

    this.olPlaceLayer = new ol.layer.Vector({
      source: this.placeSrc
    })

    const clusterSrc = new ol.source.Cluster({
      distance: this.clusterDistance,
      source: this.placeSrc
    })
    this.styleCache = {}
    this.singleIconStyleFunc = (feature) => {
        let size = feature.get('features').length;
        let style = this.styleCache[size];
          const properties = feature.get('features')[0].getProperties();
          let building_type = properties.building_type;
          let has_tour = !!properties.tour;

          style = this.styleCache[building_type];
          if (style)
            return style
          this.styleCache[building_type] = iconStyle(building_type, has_tour);  
          return this.styleCache[building_type]
      };
    this.multiIconStyleFunc = (feature) => {
        if (!feature) {
          return null
        }
        let size = feature.get('features').length;
        let style = this.styleCache[size];
        if (size == 1 || editMode) {
          const properties = feature.get('features')[0].getProperties();
          let building_type = properties.building_type;
          let has_tour = !!properties.tour;

          style = this.styleCache[building_type];
          if (style)
            return style
          this.styleCache[building_type] = iconStyle(building_type, has_tour);  
          return this.styleCache[building_type]
        } else {
          if (style)
            return style

          style = new ol.style.Style({
            image: new ol.style.Circle({
              radius: 18,
              stroke: new ol.style.Stroke({
                color: [30, 54, 128, 0.5],
                width: 10
              }),
              fill: new ol.style.Fill({
                color: [30, 54, 128]
              })
            }),
            text: new ol.style.Text({
              text: size.toString(),
              font: 'bold 14px "Helvetica Neue", Arial, Helvetica, sans-serif',
              fill: new ol.style.Fill({
                color: '#fff'
              })
            }),
            atlasManager: this.olAtlasManager
          });
          this.styleCache[size] = style;
          return style
        }
      };
    this.olClusterLayer = new ol.layer.Vector({
      source: clusterSrc,
      style: this.multiIconStyleFunc
    });

    this.olMap = new ol.Map({
      target: mapElement,
      controls: ol.control.defaults({attributionOptions: {collapsible: false}}),
      layers: [
        mapLayer,
        this.olClusterLayer
      ],
      view: olView,
      renderer: 'canvas' //'webgl'
    })

    this.olMap.once('postrender', (event) => {
      onLoading(false);
      this.olSidebarControl.open('search')
    });

    this.popupElement = ReactDOM.findDOMNode(this.refs.popup)
    this.popupCloser = ReactDOM.findDOMNode(this.refs.popupCloser)
    this.popup = new ol.Overlay({
      element: this.popupElement,
      autoPan: true,
      autoPanAnimation: {
        duration: 250
      } 
    })
    this.olMap.addOverlay(this.popup)

    this.olSidebarControl = new ol.control.Sidebar({ element: 'sidebar', position: 'left' });
    this.olMap.addControl(this.olSidebarControl);

    const logoControl = function(opt_options) {
      var element = document.createElement('div');
      element.className = 'logo-control ol-unselectable ol-control';
      ol.control.Control.call(this, {
        element: element
      });
    };
    ol.inherits(logoControl, ol.control.Control);
    const logo = new logoControl()
    this.olMap.addControl(logo);

    this.olSelectInteraction = new ol.interaction.Select({
      layers: [this.olClusterLayer],
    })
    this.olMap.addInteraction(this.olSelectInteraction)

    this.olHoverInteraction = new ol.interaction.Select({
        condition: ol.events.condition.pointerMove,
        layers: [this.olClusterLayer],
        style: this.olClusterLayer.getStyle()
    })
    this.singleHoverInteraction = new ol.interaction.Select({
        condition: ol.events.condition.pointerMove,
        layers: [this.olClusterLayer],
        style: this.singleIconStyleFunc
    })
    this.olMap.addInteraction(this.olHoverInteraction)

    this.olMap.on('click', this.clickHandler, this)

    this.olSelectInteraction.on('select', this.selectHandler, this)
    this.olHoverInteraction.on('select', this.hoverHandler, this)

    this.updateAllPlaces()
  }

  handleClusterTranslationUpdate() {
    const {selected} = this.props

    this.olMap.removeInteraction(this.olTranslateInteraction)

    const translatingFeature = this.olClusterLayer.getSource().getFeatures().filter(
      cluster => cluster.getProperties()['features'].filter(
        feature => feature.getId() == selected
      ).length
    );
    
    this.olTranslateInteraction = new ol.interaction.Translate({
        features: new ol.Collection(translatingFeature),
        style: this.singleIconStyleFunc,
    });
    
    this.olMap.addInteraction(this.olTranslateInteraction)

    this.olTranslateInteraction.on('change', this.saveFeatureGeomFromClusterToPlace, this)
  }

  saveFeatureGeomFromPlaceToCluster() {
    const {selected} = this.props;
    console.log('saveFeatureGeomFromPlaceToCluster id: '+selected);
    this.onSaveFeatureGeom(selected, 'place')
  }

  saveFeatureGeomFromClusterToPlace() {
    const {selected} = this.props;
    console.log('saveFeatureGeomFromClusterToPlace id: '+selected);
    this.onSaveFeatureGeom(selected, 'cluster')
  }

  stopDrawing(event) {
    const {onEditModeChange, onSelectClick, onAddModeChange, doneSavingFeatureGeomReturning} = this.props
    event.feature.setId('tmp')
    //this.olClusterLayer.getSource().getSource().addFeature()
    // this.olClusterLayer.getSource().getSource().getFeatureById('tmp')
    doneSavingFeatureGeomReturning(event.feature)
    this.olDrawInteraction.setActive(false)
    onSelectClick('tmp')
    this.handleClusterTranslationUpdate()
    this.olMap.on('moveend', this.handleClusterTranslationUpdate, this)
  }

  getVisibleFeatures () {
    if (this.olMap) {
      const size = this.olMap.getSize()
      const view = this.olMap.getView()
      if (view) {
        const extent = view.calculateExtent(size)
        if (this.olClusterLayer) {
          const source = this.olClusterLayer.getSource()
          if (source) {
            return source.getFeaturesInExtent(extent)
          }
        }
      }
    }
    return null
  }

  async componentWillUpdate(nextProps) {
    const {
      selected, onSelectClick, doHidePopup, openPanel, deletedFeature, featureWasDeleted, collapsed, isPanelOpened, editMode, doneSavingFeatureGeom,
      saveFeatureGeomId, savePlaceOrCluster, addingFeature, doneSavingFeatureGeomReturning, shouldBeShownIds
    } = nextProps;

    if (shouldBeShownIds !== this.props.shouldBeShownIds && shouldBeShownIds) {
      const ssids = new Set(shouldBeShownIds.map(f=>f.feature_id))
      const tmpSource = new ol.source.Cluster({
        distance: this.clusterDistance,
        source: new ol.source.Vector({
          features: this.placeSrc.getFeatures().filter(f => ssids.has(f.getId()))
        })
      })

      this.olClusterLayer.setSource(tmpSource);
    }

    if (addingFeature !== this.props.addingFeature) {
      if (addingFeature) {
          if (addingFeature !== null && typeof(addingFeature) === 'object' && addingFeature[0] === 'new') {
            const newFeature = new ol.Feature(new ol.geom.Point(addingFeature[1]))
            this.olPlaceLayer.getSource().addFeature(newFeature)
            this.olPlaceLayer.getSource().refresh()
            this.stopDrawing({feature: newFeature})
            this.olMap.getView().fit(
              newFeature.getGeometry().getExtent(),
              {
                duration: 1000
              }
            )
          } else {
            if (!this.olPlaceLayer.getSource().getFeatureById('tmp')) {
              this.olDrawInteraction = new ol.interaction.Draw({
                source: this.olPlaceLayer.getSource(),
                type: 'Point'
              })
              this.olDrawInteraction.once('drawend', this.stopDrawing, this)
            }
            this.olMap.removeInteraction(this.olSelectInteraction)
            this.olMap.removeInteraction(this.olHoverInteraction)
            this.olMap.un('click', this.clickHandler, this)
            this.olMap.addInteraction(this.olDrawInteraction)
          }
      } else {

          if (saveFeatureGeomId) {
            this.onSaveFeatureGeom(selected, savePlaceOrCluster)
          }
          this.olMap.removeInteraction(this.olDrawInteraction)
          this.olMap.addInteraction(this.olSelectInteraction)
          this.olMap.addInteraction(this.olHoverInteraction)
          this.olMap.on('click', this.clickHandler, this)
          this.olMap.un('moveend', this.handleClusterTranslationUpdate, this)
      }
    }

    if (editMode !== this.props.editMode) {
        console.log('edit changed to mode: '+ editMode + ' selected: ' + selected)

        if (editMode) {
          this.handleClusterTranslationUpdate()
          this.olMap.removeInteraction(this.olSelectInteraction)
          this.olMap.removeInteraction(this.olHoverInteraction)
          this.olClusterLayer.setStyle(this.singleIconStyleFunc)
          this.olMap.un('click', this.clickHandler, this)
          this.olMap.on('moveend', this.handleClusterTranslationUpdate, this)
        }
        else {
          if (saveFeatureGeomId) {
            this.onSaveFeatureGeom(selected, savePlaceOrCluster)
            doneSavingFeatureGeom()
          }

          this.olMap.removeInteraction(this.olTranslateInteraction)
          this.olMap.addInteraction(this.olSelectInteraction)
          this.olMap.addInteraction(this.olHoverInteraction)
          this.olClusterLayer.setStyle(this.multiIconStyleFunc)
          this.olMap.on('click', this.clickHandler, this)
          this.olMap.un('moveend', this.handleClusterTranslationUpdate, this)
        }
    }

    await this.updateSelection(selected, false)

    if (deletedFeature && this.olPlaceLayer && this.olPlaceLayer.getSource()) {
      this.olPlaceLayer.getSource().removeFeature(
        this.olPlaceLayer.getSource().getFeatureById(deletedFeature)
      )
      featureWasDeleted()
      onSelectClick(null)
      doHidePopup(true)
      doHidePopup(false)
      openPanel('search')
    }

    if (this.olSidebarControl && collapsed) {
      this.olSidebarControl.close()
    }

    if (isPanelOpened === 'editor') {
      this.olSidebarControl.open('editor');
    } else if (isPanelOpened === 'search') {
      this.olSidebarControl.open('search');
    } else if (isPanelOpened === 'new') {
      this.olSidebarControl.open('new');
    }
  }

  showPopup(position) {
    const {doHidePopup} = this.props
    this.popup.setPosition(position)
  }

  hidePopup() {
    this.popup.setPosition(undefined)
    
    // if (e !== null && 'target' in e)
    //   e.target.blur()
    
    return false
  }

  async onMultiselectSelection(id) {
    const { onSelectClick } = this.props
    const selectedFeature = this.olPlaceLayer.getSource().getFeatureById(id)
    await this.updateFeature(selectedFeature)
    this.updateAllPlaces()
    onSelectClick(id)
    this.olSidebarControl.open('editor');
  }

  render () {
    const styles = { height: '100%', width: '100%' }
    const { loading, editMode, hidePopup, selected, onSelectClick, accessibilityVersion } = this.props
    
    if (editMode || hidePopup) {
      this.hidePopup()
    }

    return (
        <div style={styles}>
          <div ref='map' style={styles} className='sidebar-map'>
            <div ref='popup' style={loading ? {display: 'none'} : (accessibilityVersion ? {zoom: 1.2} : null)} 
              className='ol-popup'>
              <PopupContentContainer onClick={(id) => this.onMultiselectSelection(id)}/>
            </div>
          </div>
        </div>
    )
  }
}

export default MapComponent



// WEBPACK FOOTER //
// ./src/MapComponent.js